// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DX1S-","right":"styles_right__16bhp"};